import { Component, Input, inject, input, output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Purpose } from 'src/app/core/models/purpose';
import { RightSidenavService } from '../../services/right-sidenav.service';
import { Mongo } from 'src/app/core/models/mongo';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatDatepickerToggle } from '@angular/material/datepicker';
import { MatDivider } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-purpose',
    template: `
    <section class="row">
      <div class="col-5 mr-auto my-2" [class.text-muted]="purpose.deletedFrom"><span class="display-4">{{ 'PURPOSE.LABEL' | translate }} {{ purposeIndex() + 1 }}</span>
      @if(purpose.deletedFrom) {
        <span class="text-primary"> (eliminata)</span>
      }
      </div>
      @if (!isReadOnly() && !purpose.deletedFrom) {
        <div class="col-7 d-flex justify-content-end">
          <button class="ms-2" mat-stroked-button color="primary" (click)="edit()">{{ 'EDIT' | translate }}</button>
          <button class="ms-2" mat-stroked-button color="warn" (click)="onRemove()">{{ 'DELETE' | translate }}</button>
        </div>
      }
    </section>

    <section class="row mt-2">
      <mat-form-field class="col-12 col-lg-8">
        <mat-label>{{ 'PURPOSE.LABEL' | translate }}</mat-label>
        <input matInput [value]="purpose.title" readonly/>
      </mat-form-field>

      @if (purpose.deletedFrom) {
        <mat-form-field class="col-12 col-lg-4">
          <mat-label>{{ 'PURPOSE.DELETED_FROM' | translate }}</mat-label>
          <input matInput value="{{purpose.deletedFrom | date: 'dd/MM/yyyy'}}" readonly>
          <mat-datepicker-toggle matIconSuffix></mat-datepicker-toggle>
        </mat-form-field>
      } @else {
        <mat-form-field class="col-12 col-lg-4">
          <mat-label>{{ 'PURPOSE.EFFECTIVE_FROM' | translate }}</mat-label>
          <input matInput value="{{effectiveFrom | date: 'dd/MM/yyyy'}}" readonly>
          <mat-datepicker-toggle matIconSuffix></mat-datepicker-toggle>
          @if(!this.purpose.effectiveFrom) {
          <span class="text-warn">{{ 'purpose.component.dovresti-aggiornare-' | translate }}</span>
          }
        </mat-form-field>
      }

      <mat-form-field class="col-12">
        <mat-label>{{ 'PURPOSE.DESCRIPTION_LIMITS' | translate }}</mat-label>
        <textarea matInput [value]="purpose.description"  readonly></textarea>
      </mat-form-field>
    </section>

    <mat-divider class="mt-1 mb-3"/>
    `,
    styles: [],
    imports: [MatButton, MatFormField, MatLabel, MatInput, MatDatepickerToggle, MatSuffix, MatDivider, TranslateModule, DatePipe]
})
export class PurposeComponent {
  private rightSidenavSrv = inject(RightSidenavService);
  private activatedRoute = inject(ActivatedRoute);

  @Input() purpose!: Purpose;
  readonly purposeIndex = input.required<number>();
  readonly isReadOnly = input.required<boolean>();
  readonly remove = output<number>();
  readonly revert = output<number>();

  onRemove() {
    this.remove.emit(this.purposeIndex());
  }

  onRevert() {
    this.revert.emit(this.purposeIndex());
  }

  edit() {
    this.rightSidenavSrv.open('compose', this.activatedRoute.parent, { purpose: this.purpose });
  }

  get effectiveFrom(): Date {
    return this.purpose.effectiveFrom ? new Date(this.purpose.effectiveFrom) : new Date(1483272000000);
  }
}
